import React from 'react';
import { More } from '../contextMenu/more';
import { Button } from '../inputs/button';
import { Email } from '../links/email';
import { Telephone } from '../links/telephone';
import { LoadText } from '../load/loadText';
import { ProfilePhoto } from '../profilePhoto/profilePhoto';
import { ReactComponent as WarningIcon } from './../../../assets/icons/warning.svg';

import { ReactComponent as UsersIcon } from './../../../assets/icons/users.svg';
import { ReactComponent as DeleteIcon } from './../../../assets/icons/delete.svg';
import { Card } from './card';



import styles from './userTallCard.module.css';
import { css } from '../../../services/css';



/**
 * @param {Object} props
 * @param {Object} props.data User Data
 * @param {boolean} [props.loading=false] Should appear as loading
 * @param {boolean} [props.disabled=false] Disabled
 * @param {string} [props.actionText=View] Text that appears in button below user
 * @param {() => void} [props.onSelect=() => {}] Callback function to call when user is selected
 */
export const UserTallCard = ({
    data = {},
    loading = false,
    disabled = false,
    actionText = 'View',
    onSelect = () => {}
}) => {
    return <Card
        className={styles.UserCard}
    >
        <div className={styles.Layout}>

            {data.archived &&
            <div className={css('icon', styles.ArchivedUserIcon)} title='User is Archived'>
                <WarningIcon />
            </div>
            }

            <div className={styles.ProfilePicture}>
                <ProfilePhoto userId={data.id} hasProfilePhoto={data.hasProfilePhoto} />
            </div>
            
            <h1>{loading ? <LoadText /> : data.displayName}</h1>

            <div className={styles.Stats}>
                { loading ? <h3><LoadText /></h3> : data?.mail && <h3><Email email={data.mail} /></h3>}
                { data?.mobilePhone && <h3><Telephone number={data?.mobilePhone} /></h3>}
                { loading ? <h3><LoadText /></h3> : data.authorizedForSystemCount == null ? <h3></h3> : <h3>{data.authorizedForSystemCount ?? 0} accessible system{data.authorizedForSystemCount === 1 ? '' : 's'}</h3>}
            </div>

            <div className={styles.Action}>
                <Button
                    className='primary'
                    disabled={disabled || loading}
                    onClick={() => onSelect()}
                >{actionText}</Button>
            </div>
        </div>

    </Card>
}